export const LINK_BOOK_NOW =
  "https://www.fresha.com/book-now/garden-and-bee-g0wbu1pt/all-offer?share&pId=1409932";
export const LINK_INSTAGRAM = "https://www.instagram.com/gardenandbeebeauty";
export const LINK_TIKTOK = "https://www.tiktok.com/@gardenandbeebeauty";
export const LINK_FACEBOOK =
  "https://www.facebook.com/people/Garden-and-Bee/61571611816778";
export const LINK_GOOGLE_MAPS = "https://maps.app.goo.gl/FY15inJSeKevoHnBA";
export const PHONE_NUMBER = "tel:7327590070";
export const EMAIL = "mailto:gardenandbee@gmail.com";
export const LINK_LEAVE_A_REVIEW = "https://g.page/r/CZ-dwOQPLQSgEBM/review";
